import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const managechannelBannerApi = createAsyncThunk(
    'auth/pages',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.channelBannerAction("add"),
                { params: data },
            )
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "", total: 0 }

const managechannelBanner = createSlice({
    name: 'page',
    initialState,
    reducers: {
        resetChannelBanner: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(managechannelBannerApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(managechannelBannerApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.results
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(managechannelBannerApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetChannelBanner } = managechannelBanner.actions;

export const managechannelBannerReducer = managechannelBanner.reducer